// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"812b44d1","498":"605707df","703":"8accaec7","787":"24f86faa"}[chunkId] + ".chunk.js";
};